import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import './Timeline.scss';

import {goToStory, setSeekVideo, startDriving} from '../../state/actions/timeline';

class Timeline extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            controllerHeight: 0
        }
    }

    render() {
        if (!this.props.timeline.currentTime || !this.props.timeline.tripStarted) return null;

        const stories = this.buildStoryDots();
        const currentPositionPercentage = this.currentPositionPercentage();

        const youAreHere = this.state.controllerHeight ? null : <div className="Map__timeline__youAreHere" style={{height: `${currentPositionPercentage}%`}}></div>;

        return (
            <div className="Map">
                <div className="Map__timeline" onMouseLeave={this.onControllerMouseOut.bind(this)}>
                    <div className="Map__timeline__line"></div>
                    {youAreHere}
                    <div className="Map__timeline__controller" onClick={this.onControllerClick.bind(this)} onMouseOver={this.onControllerHover} onMouseMove={this.onControllerMouseMove.bind(this)}>
                        <div className="Map__timeline__controller__line" style={{height: `${this.state.controllerHeight}%`}}></div>
                    </div>
                    {stories}
                </div>
            </div>
        );
    }

    buildStoryDots () {
        return this.props.timeline.data.filter((item) => {
            return item.type === "story";
        }).map((story, index) => {
            // Calculate percentage from top
            const percentage = story.time / this.props.timeline.videoDuration * 100;

            // Set classes
            const activeStory = this.props.timeline.showStory;
            const className = classNames({
                "Map__dot": true,
                "Map__dot--visited": this.props.timeline.currentTimePerSecond >= story.time,
                "Map__dot--active": activeStory && story.time === activeStory.time // Active class
            });

            return <div key={index} className={className} style={{top: `${percentage}%`}} onClick={this.goToStory.bind(this, story)}></div>;
        });
    }

    currentPositionPercentage () {
        return this.props.timeline.currentTimePerSecond / this.props.timeline.videoDuration * 100;
    }

    onControllerMouseMove (e) {
        this.setState({controllerHeight: this.calculateControllerPercentage(e)});
    }

    onControllerClick (e) {
        const time = this.calculateControllerVideoTime(e);

        if (time) {
            this.props.setSeekVideo(time);

            if (this.props.timeline.showStory) {
                this.context.router.push("/");
                this.props.startDriving();
            }
        }
    }

    calculateControllerVideoTime (e) {
        const percentage = this.calculateControllerPercentage(e);

        return percentage ? (this.props.timeline.videoDuration / 100) * percentage : 0;
    }

    calculateControllerPercentage (e) {
        const clientY = e.clientY;
        const {top, height} = e.target.getBoundingClientRect();

        const Y = height - (clientY - top);

        return Y / height * 100;
    }

    onControllerMouseOut () {
        this.setState({controllerHeight: 0});
    }

    goToStory (story) {
        if (this.props.timeline.storyIsOpen) {
            this.context.router.push(story.link.url);
        } else {
            this.props.goToStory(story);
        }
    }

}

function mapStateToProps({timeline}) {
    return { timeline }
}

export default connect(mapStateToProps, {goToStory, setSeekVideo, startDriving})(Timeline);



// WEBPACK FOOTER //
// ./src/components/Timeline/index.js